import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Loader2, History, AlertTriangle } from 'lucide-react';

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem('dentalToken')}` } });
const fmt = (d) => (d ? new Date(d).toLocaleString('en-US', { month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }) : '');
const COLORS = {
  note: 'bg-slate-200 text-slate-800',
  voice_command: 'bg-sky-100 text-sky-800', dictation: 'bg-cyan-100 text-cyan-800', 'ai-referral': 'bg-teal-100 text-teal-800',
  portal_link: 'bg-indigo-100 text-indigo-800', import: 'bg-slate-200 text-slate-700', ecard: 'bg-pink-100 text-pink-800', tooth_guides: 'bg-emerald-100 text-emerald-800', form_reminder: 'bg-amber-100 text-amber-800',
};

const Entry = ({ a }) => (
  <li className="relative pl-6 pb-5 border-l-2 border-gray-200 last:border-transparent" data-testid={`activity-${a.id}`}>
    <span className={`absolute -left-[7px] top-1 h-3 w-3 rounded-full ${a.isAlert ? 'bg-rose-500' : 'bg-sky-500'}`} />
    <div className="flex flex-wrap items-center gap-2 text-xs text-gray-500 mb-1">
      <span className={`px-2 py-0.5 rounded-full font-semibold ${COLORS[a.source] || 'bg-gray-100 text-gray-700'}`}>{a.sourceLabel}</span>
      <span>{fmt(a.at)}</span><span>· by {a.byName}{a.provider ? ` (${a.provider})` : ''}</span>
    </div>
    {a.note && <p className="text-sm text-gray-800">{a.note}</p>}
    {a.extra?.length > 0 && (
      <ul className="mt-1 space-y-0.5">
        {a.extra.map((x, i) => (
          <li key={i} className={`text-xs flex gap-1 ${String(x).startsWith('ALERT') ? 'text-rose-700 font-semibold' : 'text-gray-600'}`}>
            {String(x).startsWith('ALERT') ? <AlertTriangle className="h-3 w-3 mt-0.5 shrink-0" /> : '•'} {x}
          </li>
        ))}
      </ul>
    )}
  </li>
);

export const PatientActivityTab = ({ patientId }) => {
  const [items, setItems] = useState(null);
  useEffect(() => {
    setItems(null);
    axios.get(`${BACKEND}/api/patient-records/${patientId}/activity`, auth()).then((r) => setItems(r.data.data || [])).catch(() => setItems([]));
  }, [patientId]);
  if (!items) return <div className="py-8 text-center"><Loader2 className="h-6 w-6 animate-spin mx-auto text-sky-600" /></div>;
  if (!items.length) {
    return <div className="text-center py-10 text-gray-500" data-testid="patient-activity-empty"><History className="h-10 w-10 mx-auto mb-2 text-gray-300" />No notes yet. Add one from Dictate Visit. Notes are never sent to the patient.</div>;
  }
  return <ul className="pt-1 max-h-[560px] overflow-y-auto" data-testid="patient-activity-tab">{items.map((a) => <Entry key={a.id} a={a} />)}</ul>;
};

export default PatientActivityTab;
